var map = {
	"./music-instructions.json": 4351,
	"./music-library-intro2024.json": 4352,
	"./music-library-launch2024.json": 4353,
	"./music-progression.json": 4354,
	"./startSourcesAdvanced.json": 4355,
	"./startSourcesSimple.json": 4356,
	"./startSourcesSimple2.json": 4357,
	"./startSourcesTracks.json": 4358
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4117;